import {
  COMPANY_POLICIES_SET_LOADING,
  COMPANY_POLICIES_SET_ERROR,
  COMPANY_POLICIES_SET_POLICIES,
  COMPANY_POLICIES_FETCH_POLICIES,
  COMPANY_POLICIES_GET_POLICIES,
  COMPANY_POLICIES_GET_LOADING,
  COMPANY_POLICIES_GET_ERROR
} from './types';
import { policyService } from '@/network';

const state = {
  policies: [],
  loading: false,
  error: null
};

const mutations = {
  [COMPANY_POLICIES_SET_LOADING](state, value) {
    state.loading = value;
  },
  [COMPANY_POLICIES_SET_ERROR](state, error) {
    state.error = error;
  },
  [COMPANY_POLICIES_SET_POLICIES](state, policies) {
    state.policies = policies;
  }
};

const actions = {
  async [COMPANY_POLICIES_FETCH_POLICIES]({ commit }, { companyId }) {
    commit(COMPANY_POLICIES_SET_LOADING, true);
    try {
      const policies = await policyService.getPolicies({
        companyId
      });
      commit(COMPANY_POLICIES_SET_POLICIES, policies);
      commit(COMPANY_POLICIES_SET_ERROR, null);
    } catch (err) {
      const msg =
        err.response?.data?.message ||
        'Ocurrió un error al obtener las pólizas de la empresa';
      console.error(err);
      commit(COMPANY_POLICIES_SET_ERROR, msg);
    } finally {
      commit(COMPANY_POLICIES_SET_LOADING, false);
    }
  }
};

const getters = {
  [COMPANY_POLICIES_GET_POLICIES]: (state) => state.policies,
  [COMPANY_POLICIES_GET_LOADING]: (state) => state.loading,
  [COMPANY_POLICIES_GET_ERROR]: (state) => state.error
};

export default {
  state,
  mutations,
  actions,
  getters
};
